import { createSlice } from "@reduxjs/toolkit";

const layoutSlice = createSlice({
  name: "laout",
  initialState: {
    layoutArray:[]
  },
  reducers: {
    getLayout: (state, action) => {
  state.layoutArray =action.payload;
 },
 },
});

export const { getLayout } = layoutSlice.actions;
export default layoutSlice.reducer;
